import { TInitialState } from '~/src/features/tariffBuilder/reducer';
import getDecoders from '~/src/features/tariffBuilder/selectors/getDecoders';

const isSelectedDecoderInCurrentTariff = (state: TInitialState) => {
    if (state.currentTariff) {
        return getDecoders(state).some(el => el.isSelected);
    }
    return false;
};

export default isSelectedDecoderInCurrentTariff;
